import { CriteoOneTagEvent } from '@/services/TrackerService/Criteo/interface';
import * as yaNative from '@yanolja-org/ya-native';

// criteo 기기 구분값.
let deviceType: 't' | 'm' | 'd';
let initialized = false;

/**
 * Criteo OneTag 이벤트 전송 객체
 * @see {@link https://docs.google.com/spreadsheets/d/1XJ2-sOkp4IXiojAkX2SXXegTPHUU2iQxXrwRlTeeMa4/edit#gid=871061034}
 * @see {@link https://guides.criteotilt.com/onetag/onetag_ko/?accountid=60428&advertisername=Yanolja+KR&subdomain=&domain=&homepageurl=http%3A%2F%2Fyanolja.com%2F&accuratekey=yanoljakr%3B7832890%3B7832891%3B60428#_5}
 */
const _CriteoTracker = {
  /**
   * Criteo API 초기화 함수
   * criteo는 고객사 id (야놀자:60428)를 이용하여 JS 파일을 로드하므로 API key를 따로 입력받지 않는다.
   */
  initialize(): void {
    // GA4 웹/앱 분기처리 전송
    if (typeof window === 'undefined' || initialized || yaNative.getYaNative().isEnabled) return;

    // criteo 스크립트 삽입
    const $script = document.createElement('script');
    $script.async = true;
    $script.src = `//dynamic.criteo.com/js/ld/ld.js?a=60428`;
    document.head.append($script);

    // 기본 초기화 구문 처리
    window.criteo_q = window.criteo_q || [];
    deviceType = /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)
      ? 'm'
      : 'd';

    // 이미 스크립트 삽입된 경우 재실행 방지
    initialized = true;
  },

  /**
   * Criteo OneTag 전송 함수.
   * setAccount, setSiteType은 기본값 처리하므로 전송할 필요 없음
   * @param events {CriteoOneTagEvent[]}
   */
  push(events: CriteoOneTagEvent[]): void {
    if (typeof window === 'undefined' || yaNative.getYaNative().isEnabled) return;

    // 기본 배열 처리
    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      ...events,
      // 사이트 계정 구분값(야놀자)
      { event: 'setAccount', account: 60428 },
      // 사이트에 접속한 디바이스 타입 구분 값
      { event: 'setSiteType', type: deviceType },
      { event: 'setEmail', email: '', hash_method: '' },
      { event: 'setZipcode', zipcode: '' },
    );
  },
};

export default _CriteoTracker;
